import Vue from 'vue'
/* 日期格式化为YY-MM-DD hh:mm:ss
入参：YY-MM-DDThh:mm:ss
*/
Vue.filter("idcard",(value)=>{
	if(value){
		return value.replace(/(.{6}).*(.{4})/, '$1********$2')
	}else{
		return "暂无";
	}
});
Vue.filter("name",(value)=>{
	if(value){
		if(value.length>2){
			return  value.substr(value.length-2,2)
		}
		return value.replace(/(.{6}).*(.{4})/, '$1********$2')
	}else{
		return "暂无";
	}
});

